import { createFileRoute, Link } from "@tanstack/react-router";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import HgBreadcrumbs from "@/common/components/ui/atoms/HgBreadcrumbs";
import AdminSetsList from "@/features/assessments/components/admin/AdminSetsList";
import { useSetsPermissions } from "@/pages/admin/sets";

export const Route = createFileRoute("/app/admin/sets/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { userCanEditAllSets, userCanViewAllPrograms, userCanViewAllSets } = useSetsPermissions();

  return (
    <>
      <HgBreadcrumbs
        options={[
          { title: "Admin", link: null, unlink: true },
          { title: "Assessments", link: null },
        ]}
      />
      <h1>Assessment Management</h1>
      <p>
        <Button
          disabled={!userCanEditAllSets}
          color="primary"
          variant="contained"
          size="small"
          component={Link}
          startIcon={<AddIcon />}
          to="/app/admin/sets/new"
        >
          New Assessment
        </Button>
      </p>
      <AdminSetsList
        userCanViewAllPrograms={userCanViewAllPrograms}
        userCanViewAllSets={userCanViewAllSets}
      />
    </>
  );
}
